"use client"

// src/portal-provider.tsx
import { createContext } from "@yamada-ui/utils";
var [PortalProvider, usePortal] = createContext({
  name: "PortalContext",
  strict: false
});

export {
  PortalProvider,
  usePortal
};
//# sourceMappingURL=chunk-KRSUD7HN.mjs.map